export default __webpack_public_path__ + "static/media/proposalImg.10c14d2a.png";